// @flow
import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';

import { DeleteButton } from '../presentational/buttons/DeleteButton';
import NativeInferencePoolDeleteWarningModal from '../views/native-inference-summary/NativeInferencePoolDeleteWarningModal';

export const NativeInferencePoolDeleteContainer = () => {
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const { values } = useFormikContext();
  const { nativeInferencePoolId } = useParams();

  return (
    <>
      <DeleteButton
        onClick={() => {
          setDeleteModalOpen(true);
        }}
        size="large"
      />
      <NativeInferencePoolDeleteWarningModal
        isOpen={isDeleteModalOpen}
        nativeInferencePoolId={nativeInferencePoolId}
        poolName={values?.name}
        setOpen={setDeleteModalOpen}
      />
    </>
  );
};
